import s from "styled-components";

export const Nav = s.nav`
  margin-bottom: 25px;
  display: flex;
  ul {
    display: flex;
    align-items: center;
  }
  li {
    margin: 0 5px;
    :first-child {
      margin-left: 0;
    }
  }
`;
export const Tags = s.ul`
  margin-left: 10px;
  li {
    margin: 3px 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    background-image: ${({ theme }) => theme.gradient.primary.normal};
    color: white;
    border-radius: 24px;
    padding: 6px 13px;
    padding-right: 9px;
    font-weight: 600;
    :hover {
      background: ${({ theme }) => theme.gradient.primary.hover};
    }
  }
  button {
    margin-left: 8px;
    padding-bottom: 1px;
  }
`;
